module.exports = __webpack_public_path__ + "static/img/zzjs_01.b3cd9f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zzjs_01.png
// module id = 3ZIH
// module chunks = 1